import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'tenant-seat-structure',
  standalone: true,
  imports: [CommonModule],
  template: `
     <div class="flex justify-between">
          <div class="flex items-center gap-2">
            <span class="flex items-center gap-2 text-slate-500">
              <span class="h-3 w-3 inline-block bg-silver"></span>
              Silver:</span
            >
            <span class="text-sm"> {{ silverSeats }} </span>
          </div>
          <div class="flex items-center gap-2">
            <span class="flex items-center gap-2 text-slate-500">
              <span class="h-3 w-3 inline-block bg-bronze"></span>
              Bronze:</span
            >
            <span class="text-sm"> {{ bronzeSeats }} </span>
          </div>
          <div class="flex items-center gap-2">
            <span class="flex items-center gap-2 text-slate-500">
              <span class="h-3 w-3 inline-block bg-gold"></span> Gold:</span
            >
            <span class="text-sm"> {{ goldSeats }} </span>
          </div>
        </div>
  `,
  styles: ``,
})
export class SeatStructureComponent {
  @Input() silverSeats!: number;
  @Input() bronzeSeats!: number;
  @Input() goldSeats!: number;
}
